export class AzureSqlDatabaseNativePitrBackupResourceType {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType & string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureSqlDatabaseNativePitrBackupResourceType.attributeTypeMap;
    }
    constructor() {
    }
}
